import script from "./editTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./editTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./editTemplate.vue?vue&type=style&index=0&id=6b8cb406&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8cb406"]])

export default __exports__